import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

/**
 * The service checks breakpoint states with respect to the media queries.
 */
@Injectable({
  providedIn: "root",
})
export class BreakpointService {
  constructor(private breakpointObserver: BreakpointObserver) {}

  public getBreakpointState(
    mediaQueries: string | readonly string[],
  ): Observable<BreakpointState> {
    return this.breakpointObserver.observe(mediaQueries);
  }

  public isMatchingBreakpoint(
    mediaQueries: string | readonly string[],
  ): boolean {
    return this.breakpointObserver.isMatched(mediaQueries);
  }
}
